export var Guidebooks;
(function (Guidebooks) {
    Guidebooks["ISSUER"] = "Issuer";
    Guidebooks["MATERIAL"] = "Material";
    Guidebooks["CONSTRUCTION"] = "Construction";
    Guidebooks["REQUIREMENT"] = "Requirement";
})(Guidebooks || (Guidebooks = {}));
